import { FieldModel, FieldsAPI, ResourceDetail } from '@cibo/core'
import { logRequestError } from '@cibo/ui'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useInvalidateBatchedFields } from '../../../queries'
import { QUERY_KEY } from '../../../queries/queryKey'

type SaveBulkDetailsRequest = {
  resourceIds: string[]
  details: ResourceDetail[]
}

export const useSaveBulkDetails = () => {
  const queryClient = useQueryClient()

  const invalidateBatchedFields = useInvalidateBatchedFields()

  return useMutation({
    mutationFn: ({ resourceIds, details }: SaveBulkDetailsRequest) =>
      FieldsAPI.bulkUpdateFields(resourceIds, details).then(r =>
        r.items.map(f => new FieldModel(f))
      ),

    mutationKey: [QUERY_KEY.SAVE_BULK_DETAILS],
    onSuccess: (fields: Array<FieldModel>, request: SaveBulkDetailsRequest) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.FIELDS_PAGINATED] })

      invalidateBatchedFields(request.resourceIds)
    },
    onError: (error: any, variables, context) => {
      logRequestError(error, { query: 'useSaveBulkDetails', variables, context })
      return error
    },
  })
}
